
import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useLocation,useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import { withAuth } from '../AuthContext';
import { withSearch } from '../SearchContext';
import { getParameterByName } from '../../utils/utils';
import "../css/chat.css";
import { ChatMessage } from '../Utils/ChatMessage';
import { useNotification } from '../Dashboard/Notification/NotificationContext';


const Message = ({ auth }) => {
  const [hostName, setHostName] = useState('');
  const [status, setStatus] = useState('');
  const [hostId, setHostId] = useState('');
  const [guestId, setGuestId] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('locals');
  const history = useHistory();
  const location = useLocation();
  const { uuid } = useParams();
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null); 
  const from = location.state?.from || '/dashboard'; 
  const { fetchUnreadCount } = useNotification();

  const handleGoBack = () => {
    history.push(from); 
  };

 

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const fetchMessages = async () => {
    setIsLoading(true); 
    try {
      const response = await axios.get(`/api/messages/${uuid}`);
      const fetchedMessages = response.data;
  
      if (fetchedMessages) {
        const normalizedMessages = normalizeMessages(fetchedMessages);
        console.log(normalizedMessages);
        setMessages(normalizedMessages);
      } else {
        console.error("No messages found.");
      }
    } catch (error) {
      console.error("Failed to fetch messages:", error);
    } finally {
      setIsLoading(false); 
    }
  };


  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const normalizeMessages = (messages) => {
    return messages.map((msg) => ({
      id: msg.id,
      senderId: msg.userId,
      receiverId: msg.receiverId,
      message: msg.message,
      timestamp: msg.sendDate,
      hasRead: msg.hasRead,
      readByReceiver: msg.read_by_receiver,
      threadId: msg.threadId,
      bookingId: msg.bookingId,
      bookingRequestUuid: msg.booking_request_uuid,
    }));
  };

  const sendMessage = async (data) => {
    try {
      const response = await axios.post('/api/messages', data);
      return response.data;
    } catch (error) {
      console.error('Request failure:', error);
      throw error;
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault(); // Prevent form submission
    const data = {
      receiverId: hostId,
      guestId,
      message: newMessage,
      uuid,
    };

    try {
      const sentMessage = await sendMessage(data);
      const normalizedSentMessage = normalizeMessages([sentMessage])[0];

      setMessages((prevMessages) => [...prevMessages, normalizedSentMessage]);
      setNewMessage(""); 
      fetchUnreadCount()
    } catch (error) {
      console.error("Failed to send message:", error);
    }
  };

  const fetchRequestDetails = async () => {
    setIsLoading(true); 
    try {
      const response = await axios.get(`/api/bookings/request/${uuid}`);
      const requestDetails = response.data;

      console.log("details: ", requestDetails);
  
      if (requestDetails) {
        setHostId(requestDetails.host_id);
        setGuestId(requestDetails.guest_id);
        setHostName(requestDetails.hostname);
        setStatus(requestDetails.status);
        setMessage(requestDetails.message);
      } else {
        console.error('Request details not found');
      }
    } catch (error) {
      console.error('Request failure:', error);
    } finally {
      setIsLoading(false); // Set loading to false after fetching data
    }
  };

  useEffect(() => {
    fetchMessages();
    fetchRequestDetails();
  }, [uuid]);

// useEffect(() => {
//     // Fetch existing messages for the request
//    // fetchMessages(requestId).then((fetchedMessages) => setMessages(fetchedMessages));


//     axios
//     .get(`/api/bookings/request/${uuid}`)
//     .then(response => {
//       console.log(response.data); // Log the entire response to check its structure
//       const requestDetails = response.data;
//       console.log(requestDetails);
//       if (requestDetails) {
//           setHostId(requestDetails.host_id);
//           setGuestId(requestDetails.guest_id);
//           setHostName(requestDetails.hostname);
//           setStatus(requestDetails.status)
//           setMessage(requestDetails.message)
//       } else {
//         console.error('requestDetails is undefined or missing');
//       }
//     })
//     .catch(error => {
//       console.error('Request failure:', error);
//     });


//   }, []);








//   useEffect(() => {
//     console.log("uuid:"+uuid);

    // check this on the next page!!!
    // if (!['approved', 'approvedfinal'].includes(auth.user.status)) {
    //   history.push(`/user/${uuid}`);
    //   return;
    // }

    // Fetch user data




//     axios
//       .get(`/api/users/${uuid}`)
//       .then(response => {
//         const userData = response.data.data;
//         console.log(userData);
//         setUser(userData);
//         setPlace(userData.place);
//         setMessage('');
//       })
//       .catch(error => {
//         console.error('Request failure:', error);
//       });

//     // Set type from query parameter
//     const queryType = getParameterByName('type');
//     setType(queryType || 'locals');
//   }, [auth.user.status, history, uuid]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'message') setMessage(value);
  };








  if (auth.user.status !== 'approvedfinal') {
    return (
      <section className="contact-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="contact_form">
                <h3 className="title">Send a Message - ID Verification Required</h3>
                <div>
                  <p>
                    To send messages to other Freebird members, we need to verify your identity. This ensures safety while connecting with new friends.
                  </p>
                </div>
                <div className="submit-btn">
                  <Link to="/dashboard/proof-identity">
                    <button className="btn btn-primary mr-2">
                      Upload Proof of Identity
                    </button>
                  </Link>
                  <Link to={"/dashboard/requests/live"}  onClick={handleGoBack} className="btn btn-warning mr-2 text-decoration-none">
                    Back
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
//     <section className="contact-wrapper">
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-md-8">


//           <div class="chat-container">
//     <div class="message guest">
//       Hi, can I ask about the check-in time?
//     </div>
//     <div class="message host">
//       Sure, check-in starts at 3 PM. 
//     </div>
//        <div class="message host">
//       dont mess up. 
//     </div>
//        <div class="message host">
//         Our HTML editor updates the webview automatically in real-time as you write code.
//     </div>
//         <div class="message guest">
//       ok
//     </div>
//   </div>





//             <div className="contact_form">
//               <h3 className="title">Send a Message to {hostName}</h3>
//               <div>
//                 <p>New friends, local advice, and a helping hand. A little conversation can go a long way!</p>
//               </div>
//               <div id="send-message">
//                 <form onSubmit={sendMessage}>
//                   <input type="hidden" name="csrf-token" value={window.Laravel.csrfToken} />
//                   <div className="col-12 form-group">
//                     <label>Your message</label>
//                     <textarea
//                       id="message"
//                       name="message"
//                       className="form-control"
//                       rows="5"
//                       style={{ minWidth: '100%' }}
//                       autoFocus
//                       required
//                      // value={message}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                   <div className="submit-btn">
//                     <button type="submit" className="btn btn-primary mr-2">
//                       Send
//                     </button>
//                     <Link to={"/dashboard/requests/live"} className="btn btn-warning mr-2 text-decoration-none">
//                     {/* <Link to={`/user/${user.id}`} className="btn btn-warning mr-2 text-decoration-none"> */}
//                       Return
//                     </Link>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>



<section className="contact-wrapper">
<div className="container">
  <div className="row justify-content-center">
    <div className="col-md-8">


                
        {/* Title Section */}
        <div className="chat-header">
          <h3>Chat with {hostName}</h3>
        </div>
      {/* Chat Section */}
      <div className="chat-container" style={{ maxHeight: '400px', overflowY: 'auto' }}>

        {isLoading ? (
          <div className="loading-spinner">
            <p>Loading...</p>
            {/* Replace with a spinner */}
          </div>
        ) : messages.length > 0 ? (
          messages.map((msg, index) => (
            <ChatMessage 
            key={index}
            className = {msg.senderId === guestId ?   'host': 'guest'}
            classType = {'message'}
            message={msg.message}
            timestamp={msg.timestamp}
        />
          ))
        ) : (
          <div className="no-messages">
            <div>No messages yet. Start the conversation!</div>
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      {/* Form Section */}
      <div className="contact_form" style={{ marginTop: '20px' }}>
        <form onSubmit={handleSendMessage} className="message-form">
          <textarea
            id="message"
            name="message"
            className="form-control message-box"
            rows="2"
            placeholder="Type your message..."
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            required
            style={{
              borderRadius: '5px',
              padding: '10px',
              fontSize: '14px',
              width: '100%',
              marginBottom: '10px',
            }}
          />
          <div className="form-buttons" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button 
              type="submit" 
              className="btn btn-primary" 
              disabled={isLoading}
              style={{ padding: '10px 20px', fontSize: '16px' }}
            >
              Send
            </button>
            <button
              type="button"
              onClick={handleGoBack}
              className="btn btn-secondary"
              style={{ padding: '10px 20px', fontSize: '16px' }}
            >
              Return
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</section>








  );
};

export default withSearch(withAuth(Message));



































// import React, { Component } from 'react';
// import { Link, withRouter } from 'react-router-dom';
// import moment from 'moment';
// import PropTypes from 'prop-types';
// import Select from 'react-select';
// import { withAuth } from '../AuthContext';
// import { withSearch } from '../SearchContext';
// import {getParameterByName} from "../../utils/utils";

// class Message extends Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             message: '',
//             user: {},
//             place: {},
//             type: 'locals'
//         };

//         this.handleInputChange = this.handleInputChange.bind(this);
//         this.sendMessage = this.sendMessage.bind(this);
//     }

//     componentDidMount() {
//         const {
//             match: { params }
//         } = this.props;

//         const auth = this.props.auth.user;
//         if(auth.status !== 'approved' && auth.status !== 'approvedfinal') {
//             this.props.history.push(`/user/${params.uuid}`);
//         }

//         axios
//             .get(`/api/users/${params.uuid}`)
//             .then(response => {
//                 const user = response.data.data;
//                 this.setState({ user });
//                 this.setState({ place: user.place });
//                 let message = ``;
//                 this.setState({message});
//             })
//             .catch(function(error) {
//                 console.log('Request failure: ', error);
//             });

//         const type = getParameterByName('type');
//         this.setState({type});
//     }

//     handleInputChange(event) {
//         const target = event.target;
//         const value = target.type === 'checkbox' ? target.checked : target.value;
//         const name = target.name;
//         this.setState({ [name]: value });
//     }

//     sendMessage(e) {
//         e.preventDefault();
//         const data = {
//             receiverId: this.state.user.id,
//             message: this.state.message,
//         };

//         axios
//             .post('/api/messages', data)
//             .then(() => {
//                 this.props.history.push('/dashboard/messages');
//             })
//             .catch(function(error) {
//                 console.log('Request failure: ', error);
//             });
//     }

//     render() {
//         let p = this.state.place;
//         const type = this.state.type;

//         console.log('this.props.auth.user.status: ' + this.props.auth.user.status);

//         if(this.props.auth.user.status != 'approvedfinal') {
//             return (
//                 <section className="contact-wrapper">
//                     <div className="container">
//                         <div className="row justify-content-center">
//                             <div className="col-md-8">
//                                 <div className="contact_form">
//                                     <h3 className="title">Send a Message - ID Verification Required</h3>
//                                     <div>
//                                         <p>
//                                             In order to send messages to other Freebird members we first need to verify your identity. This
//                                             is important as it allows us to ensure that all Freebird members are who they say they are, keeping
//                                             you as safe as possible while you reach out and make new friends.
//                                         </p>
//                                     </div>
//                                     <div className="submit-btn">
//                                             <Link to="/dashboard/proof-identity">
//                                                 <button className="btn btn-primary mr-2">
//                                                     Upload Proof of Identity
//                                                 </button>
//                                             </Link>
//                                             <Link to={`/user/${this.state.user.id}`} className="btn btn-warning mr-2 text-decoration-none">
//                                                 Back
//                                             </Link>
//                                         </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             );
//         }

//         return (
//             <section className="contact-wrapper">
//                 <div className="container">
//                     <div className="row justify-content-center">
//                         <div className="col-md-8">
//                             <div className="contact_form">
//                                 <h3 className="title">Send a Message to {this.state.user.forename}</h3>
//                                 <div>
//                                     <p>
//                                         New friends, local advice and a helping hand. You never know what might grow from a little conversation!
//                                     </p>
//                                 </div>
//                                 <div id="send-message">
//                                     <div id="message" />

//                                     <form
//                                         method="POST"
//                                         action="/send-message"
//                                         name="myForm"
//                                         aria-label="Send Message"
//                                         onSubmit={this.sendMessage}>
//                                         <input
//                                             type="hidden"
//                                             name="csrf-token"
//                                             value={window.Laravel.csrfToken}
//                                         />

//                                         <div className="col-12  form-group">
//                                             <label>Your message</label>

//                                             <textarea
//                                                 id="message"
//                                                 name="message"
//                                                 className="form-control"
//                                                 rows="5"
//                                                 style={{ minWidth: '100%' }}
//                                                 autoFocus
//                                                 required
//                                                 value={this.state.message}
//                                                 onChange={this.handleInputChange}
//                                             />
//                                         </div>

//                                         <div className="submit-btn">
//                                             <button type="submit" className="btn btn-primary mr-2">
//                                                 Send
//                                             </button>
//                                             <Link to={`/user/${this.state.user.id}`} className="btn btn-warning mr-2 text-decoration-none">
//                                                 Return
//                                             </Link>
//                                         </div>
//                                     </form>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         );
//     }
// }

// export default withRouter(withSearch(withAuth(Message)));
